import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bfa3fd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "huddles-topics-chart"
}
const _hoisted_2 = { class: "goal--tab" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "goal--line" }, null, -1))
const _hoisted_4 = { class: "topics-list" }
const _hoisted_5 = { class: "labels" }
const _hoisted_6 = { class: "bar" }

import { Topic } from '@/entities/huddles'
import Typography from '@/components/Rain/Typography/Typography.vue'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { faArrowDown, faArrowUp } from 'fontawesome/free-solid-svg-icons'

interface Props {
    topics: Topic[]
    baseCxscoreGoal: number | undefined
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HuddlesTopicsChart',
  props: {
    topics: {},
    baseCxscoreGoal: {}
  },
  setup(__props: any) {

const props = __props

const arrowIcon = (cxscore: number) => {
    return props.baseCxscoreGoal <= cxscore ? faArrowUp : faArrowDown
}

const getBarWidthPercentage = (cxscore: number): number => {
    const goalLinePosition = 66 // It is positioned at 66% of the width of it's container

    if (cxscore > props.baseCxscoreGoal) {
        // CX score above goal: Calculate percentage relative to space above goal
        const excessCxscore = cxscore - props.baseCxscoreGoal
        return (
            (excessCxscore / (100 - props.baseCxscoreGoal)) *
            (100 - goalLinePosition)
        )
    } else if (cxscore < props.baseCxscoreGoal) {
        // CX score below goal: Calculate percentage relative to space below goal
        const belowCxscore = props.baseCxscoreGoal - cxscore
        return (belowCxscore / props.baseCxscoreGoal) * goalLinePosition
    }
    return 0
}

return (_ctx: any,_cache: any) => {
  return (_ctx.topics.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, "Base goal " + _toDisplayString(_ctx.baseCxscoreGoal) + "%", 1),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topics, (topic, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "topic"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(Typography, {
                  variant: "caption",
                  class: "label--topic"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(topic.topic), 1)
                  ], undefined, true),
                  _: 2
                }, 1024),
                _createVNode(Typography, {
                  variant: "subtitle1",
                  class: _normalizeClass([
                            'label--cxscore',
                            { positive: _ctx.baseCxscoreGoal < topic.cxscore },
                        ])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(topic.cxscore) + " ", 1),
                    _createVNode(_unref(FontAwesomeIcon), {
                      icon: arrowIcon(topic.cxscore),
                      size: "2xs"
                    }, null, 8, ["icon"])
                  ], undefined, true),
                  _: 2
                }, 1032, ["class"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass([
                            'bar bar--overlay',
                            { positive: _ctx.baseCxscoreGoal < topic.cxscore },
                        ]),
                  style: _normalizeStyle({
                            width: `${getBarWidthPercentage(topic.cxscore)}%`,
                        })
                }, null, 6)
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})